//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import * as collectionsApi from '@apis/collections/collectionsApi';
import { SliceNames } from '@redux/SliceNames';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStreamDeleteState } from '@streams/models/streamDeleteState';
import { createThunk } from '@redux/createThunk';
const initialState: IStreamDeleteState = {
  isDeletingStream: false,
};

const { actions, reducer } = createSlice({
  name: SliceNames.StreamDelete,
  initialState,
  reducers: {
    requestDeleteStream: (state) => {
      state.isDeletingStream = true;
    },
    deleteStreamSucceeded: (state) => {
      state.isDeletingStream = false;
    },
    deleteStreamFailed: (state) => {
      state.isDeletingStream = false;
    },
  },
});

export const {
  requestDeleteStream,
  deleteStreamSucceeded,
  deleteStreamFailed,
} = actions;

export default reducer;
